import type { GamificationPage } from '@/types/gamificationPage'

type PageWithContent = GamificationPage & {
  content?: { category_ids?: number[] } | null
}

/**
 * Categorias configuradas pelo produtor para páginas de módulo parceiros.
 * O payload de `/gamification/data` expõe os filtros em `content` (não em
 * `module_filters`); o endpoint dedicado de páginas envia os dois.
 */
export function getPartnerCategoryIdsFromPage(
  page: PageWithContent
): number[] {
  const fromModuleFilters = page.module_filters?.category_ids
  if (Array.isArray(fromModuleFilters) && fromModuleFilters.length > 0) {
    return fromModuleFilters
  }

  if (page.content_kind === 'module') {
    const fromContent = page.content?.category_ids
    if (Array.isArray(fromContent) && fromContent.length > 0) {
      return fromContent
    }
  }

  return []
}

export function isPartnersModulePage(page: GamificationPage): boolean {
  return (
    page.content_kind === 'module' &&
    (page.linked_module === 'partners' || page.module_type === 'partners')
  )
}

export function buildPartnersListFilter(categoryIds: number[]) {
  return categoryIds.length > 0
    ? { partner_category_id_in: categoryIds }
    : {}
}

/**
 * Destaque "Top Curtidas" no topo da listagem de parceiros. Ausente no payload
 * mantém o comportamento legado (ligado por padrão).
 */
export function getShowTopLikesFromPage(page: PageWithContent): boolean {
  const fromModuleFilters = page.module_filters?.show_top_likes
  if (fromModuleFilters !== undefined && fromModuleFilters !== null) {
    return Boolean(fromModuleFilters)
  }

  if (page.content_kind === 'module') {
    const content = page.content
    if (content && typeof content === 'object' && 'show_top_likes' in content) {
      const fromContent = content.show_top_likes
      if (fromContent !== undefined && fromContent !== null) {
        return Boolean(fromContent)
      }
    }
  }

  return true
}
